<div class="ng-head">
    <span class="ng-title">
        <span style="top: 6px;">
            <span class="ng-icon-slot" data-icon="git-branch"> </span>
        </span>
        <span class="ng-title-text"></span>
    </span>
    <div class="ng-center">
        <button class="ng-walklink" type="button" hidden>
        <span class="ng-icon-slot" data-icon="play"></span>
        <span>Start walkthrough →</span>
        </button>
        <div class="ng-stepper" hidden>
        <button class="ng-stepbtn ng-prev" type="button" aria-label="Previous step">
            <span class="ng-icon-slot" data-icon="chevron-left"></span>
        </button>
        <span class="ng-steplabel">
            <span class="ng-stepcount"></span>
            <span class="ng-steptext"></span>
        </span>
        <button class="ng-stepbtn ng-next" type="button" aria-label="Next step">
            <span class="ng-icon-slot" data-icon="chevron-right"></span>
        </button>
        </div>
    </div>
    <div class="ng-right">
        <button class="ng-expand-btn" type="button">
        <span class="ng-icon-slot" data-icon="maximize"></span>
        Expand
        </button>
    </div>
</div>
<div class="ng-wrap">
    <div class="ng-status">Loading node graph…</div>
</div>